import { useMemo } from "react";
import { format, parseISO } from "date-fns";

export const Attribution = ({
  firstName,
  lastName,
  date,
  verb = "Completed",
}: {
  verb?: "Completed" | "Created";
  firstName?: string;
  lastName?: string;
  date?: string;
}) => {
  const by = useMemo(() => {
    return [firstName, lastName].filter(Boolean).join(" ");
  }, [firstName, lastName]);

  const on = useMemo(() => {
    if (!date) return;

    return format(parseISO(date), `MMM d, yyyy, h:mm a`);
  }, [date]);

  const prefix = by ? `${verb} by:` : `${verb} on:`;

  if (!by && !on) return null;

  return <>{`${prefix} ${[by, on].filter(Boolean).join(" | ")}`}</>;
};
